<template>
    <div class="card">
        
        <div class="card-body" v-if="employee_id > 0">
        
            <ul class="list-group mb-3 " v-if='errormsg'>           
                <li class="list-group-item list-group-item-danger" v-for='data in errormsg'>{{data[0]}}</li>
            </ul>
            {{successmsg}}
            <div class="row">
                <div class="col-sm-2"><b-avatar class="" variant="light" rounded button size="150px" :src="avatar_src"></b-avatar></div>
                <div class="col-sm-10">
                    <div class="row">
                        <div class="col-sm-6">
                            <ul class="list-group list-group-flush">
                                <li class="list-group-item">{{employee_name}}</li>
                                <li class="list-group-item">{{employee_email}}</li>
                                <li class="list-group-item">{{employee_phone}}</li>
                                <li class="list-group-item">{{employee_jobposition}}</li>
                                <li class="list-group-item">{{employee_department}}</li>
                            </ul>
                        </div>
                        <div class="col-sm-6">
                            <ul class="list-group list-group-flush">
                                <li class="list-group-item">Total working days: {{total_working_day}}</li>
                                <li class="list-group-item">Weekends: {{total_weekends}}</li>
                                <li class="list-group-item">Holiday(s): {{total_holidays}}</li>
                                <li class="list-group-item">Absent: {{total_absent}}</li>
                                <li class="list-group-item">Approved Leavs: {{total_leaves}}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            
            <div class="mt-4 employee-tab">
                <b-tabs pills content-class="" nav-class=" pr-2 m-2" nav-wrapper-class="col-md-9 custom-margin ml-auto pl-0">                                
                    <template >
                        <b-tab lazy>
                            <template active v-slot:title>Attendance</template>                
                            <div class="card clearfix">
                                <div class="card-body">
                                    <div class="row  ">
                                        
                                        <div class="col-sm-12 ">
                                            <v-calendar is-expanded  :masks="masks" :attributes="attributes" :first-day-of-week="first_day_of_week" ref="trzcalendar"
                                                class='v-calendar ' is-dark  @update:to-page="monthDetails" :from-page="page">
                                                <template slot="day-content" class='vc-w-full vc-relative' slot-scope='{day, dayEvents, attributes, attributesMap , popover}'>
                                                    <div v-bind:class='{"holiday": weekly_holidays.includes(day.weekday)}'>
                                                        <div v-if="this_month_holidays[day.id]" :style="{'background-color':this_month_holidays[day.id].color}" :title="this_month_holidays[day.id].title">                                
                                                            <div class="flex flex-column h-100 overflow-hidden">
                                                                
                                                                <div class="day-label text-sm text-gray-900 " >{{day.day}}</div>
                                                                
                                                            </div>
                                                        </div>
                                                        <div v-else>                                
                                                            <div class="flex flex-column h-100 overflow-hidden">
                                                                <div class="day-label text-sm text-gray-900" >{{day.day}}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    
                                                </template>
                                            </v-calendar>

                                            
                                            <div class="legend mt-4">                                                
                                                <div class="row trz_borders">
                                                    <div class="col-sm-2 bg-primary">Present</div>
                                                    <div class="col-sm-2 bg-danger">Absent</div>
                                                    <div class="col-sm-2  bg-secondary">Weekend</div>                                                    
                                                    <div class="col-sm-2 bg-success">Holiday</div>
                                                    <div class="col-sm-2 " style="background:#FFD300">Late</div>

                                                    <template v-for="leavetype in leavetypes">
                                                        <div class="col-sm-2 " v-bind:style="'background:'+leavetype.color_code">{{leavetype.title}}</div>
                                                    </template>
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-tab>
                        <b-tab lazy>
                            <template active v-slot:title>Leaves</template>                
                            <SubordinateLeaveFront  :key="componentKey" v-on:childToParent="helloFars"></SubordinateLeaveFront>
                        </b-tab>
                    </template>        
                </b-tabs>        
            </div>        
        </div>

    </div>
</template>
 
<script>
    import SubordinateLeaveFront from './SubordinateLeaveFront';    
    import moment from 'moment';
    export default{
        
        mounted() {
            this.$refs.trzcalendar;

            //alert( moment().year() +'>>'+ moment().month());
        },
        props: [],   
        components: {
            SubordinateLeaveFront
        },
        data(){   
            const now = new Date();    
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());     
            const maxDate = new Date(today);
            maxDate.setMonth(maxDate.getMonth());

            const minDate = new Date(today)
            minDate.setMonth(minDate.getMonth()); 
            minDate.setDate(1);
            return {

                max: maxDate,
                min: minDate,
                successmsg:'',
                errormsg:[],
                fdata: {check_in: '00:00' , checkout: '00:00' , absent:0 , attendances_date:moment.utc().local().format('MM-DD-YYYY')},
                
                just_now : moment().format("HH:mm"),
                
                

                componentKey: 0,

                avatar_src : '',
                employee_id : 0,
                employee_name : '',
                employee_jobposition : '',
                employee_department : '',
                employee_email : '',
                employee_phone : '',

                dp_today : new Date(), 

                weekly_holidays : [6],
                first_day_of_week : 7,
                this_month_holidays : [],
                week_holidays : [6],
                all_week_holidays : [6],
                holidays_date_arr : [],

                header_year_month : '',

                start_date: null,
                end_date: null,

                total_working_day : 0,
                total_weekends : 0,
                total_holidays : 0,
                total_absent : 0,
                total_leaves : 0,

                leavetypes : [],

                masks : 
                    {
                        title: 'MMMM YYYY',
                        weekdays: 'WW',
                        navMonths: 'MMM',
                        input: ['L', 'YYYY-MM-DD', 'YYYY/MM/DD'],
                        dayPopover: 'WWW, MMM D, YYYY',
                        data: ['L', 'YYYY-MM-DD', 'YYYY/MM/DD'],
                    },

                attributes: [
                        {
                            key: 'today',
                            dot: 'pink',
                            dates: new Date(),
                        }
                    ],

                page: { month: '', year: '' },
                
            }
        },
        methods:{
            
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            
            helloFars(value)
            {
                //alert(value.employee_id);
                //this.$forceUpdate();
                this.getEmployeeData();
                this.$bvModal.hide('bv-modal-employeesearch');

                let y = moment().year();
                let m = moment().month();                
                m += 1;

                this.page = { month: '', year: '' };
                this.monthDetails('' , y , m);

                this.componentKey += 1;
                
            },
            loadAttendance :function(day , title)
            {
                /*if(day < this.min)return;
                alert(this.min);
                alert(day);*/
                //alert(day + ' >> ' + title);
                //fdata: {check_in: null, checkout:null , absent:0 , attendances_date:''},
                this.fdata.absent = 0;
                this.fdata.attendances_date = day;
                if(title == 'Absent')
                {
                    this.fdata.absent = 1;
                    this.fdata.check_in = null;
                    this.fdata.checkout = null;
                }  
                else
                {
                    let x = title.split(' to ');
                    this.fdata.check_in = x[0];
                    this.fdata.checkout = x[1];
                    
                }

                
            },
            getLeaveTypes: function()
            {
                if(!this.checkNet()) return false;
                this.showoverlay = true;
                axios.get(this.$api_url+'/leave/types?f=1' , {
                    params: {
                        
                    }
                }).then(function(response){
                    
                    this.leavetypes = response.data;
                    
                }.bind(this));
            }, 
            getEmployeeData() 
            {   
                
                let currentObj = this;
                axios.get(this.$api_url+'/employee/publicinfo' , {
                    params: {
                        //id: x
                    }
                }).then(function(response){
                    
                        this.avatar_src = this.$api_url+'/images/employee/'+ response.data.company_id + '/' + response.data.pic;                       
                        this.employee_id =  response.data.employee_id;
                        this.employee_name =  response.data.name;
                        this.employee_jobposition =  response.data.jobposition;
                        this.employee_department =  response.data.department;
                        this.employee_email =  response.data.email;
                        this.employee_phone =  response.data.phone;

                        if(response.data.check_in != '00:00')
                            this.fdata.check_in = response.data.check_in;
                        
                        if(response.data.checkout != '00:00')
                            this.fdata.checkout = response.data.checkout;
                    
                }.bind(this)).catch(function (error){ currentObj.serverError(error);});
            },
            monthDetails: function(x='' , y=0, m=0)
            {                
                let currentObj = this;
                let year = 0;
                let month = 0;
                
                if(y == 0)    
                {
                    year = x['year'];
                    month = x['month'];
                }   
                else
                {
                    year = y;
                    month = m;
                }  
                
                //alert(year + ' ' + month);
                    
                let st_date = new Date(year , month - 1 , 1);
                let en_date = new Date(year , month , 0);   

                
                this.start_date = moment(String(st_date)).format('Do MMMM YYYY');
                this.end_date = moment(String(en_date)).format('Do MMMM YYYY');
                
                // fetch holidays dynamically from controller
                axios.get(this.$api_url+'/employee/attendances/details' , {
                    params: {
                        st_date: this.start_date,
                        en_date: this.end_date,
                    }
                }).then(function(response){

                    this.all_week_holidays = response.data.report.week_holidays.split(',').map(function(item){ return parseInt(item, 10);});
                    this.holidays_date_arr = response.data.report.holidays_date_arr.split(',').map(function(item){ return item;});
                    this.weekly_holidays = response.data.report.week_holidays.split(',').map(function(item){ return parseInt(item, 10) + 1;});
                    this.first_day_of_week = parseInt(response.data.report.week_start_day) + 1;
                    
                    this.this_month_holidays = response.data.holidays;

                    this.total_working_day = response.data.report.total_working_day;
                    this.total_weekends = response.data.report.weekends;
                    this.total_holidays = response.data.report.holidays;
                    this.total_absent = response.data.report.absent;
                    this.total_leaves = response.data.report.total_leaves;

                    //this.$refs.trzcalendar;
                    
                        
                }.bind(this)).catch(function (error){ currentObj.serverError(error);});;

            }, 

        },
        created: function(){
            //
            this.getEmployeeData();
            this.getLeaveTypes();
        },
        computed:
        {
            fetchStartWeekday()
            {
                return parseInt(this.first_day_of_week) - 1;
            },
        }
    }
</script>
<style>
    .trz_borders {color: #ccc;}
</style>